import { CheckboxWUT } from '@wix/form-fields/viewer-wut';

export default CheckboxWUT;
